<template>
    <el-container id="doc">

        <el-header height="50px">
            <el-row type="flex" justify="end">
                <el-col :span="20">
                    <div class="logo">
                        <el-image :src="logo"></el-image><span>正蒙英语系统</span>
                    </div>
                    <div class="head_l">
                        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="levelList.length > 1">
                            <el-breadcrumb-item v-for="(item, index) in levelList" :key="index" v-if="item.meta.title">
                                <span @click="goUrl(item.name)" >{{ item.meta.title }}</span>
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="4" style="text-align: right">
                    <div class="head_r">
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            <i class="el-icon-user-solid"></i> {{ userInfo ? userInfo.username : '' }}
                            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                          </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="updataPsd=true">修改密码</el-dropdown-item>
                                <el-dropdown-item divided @click.native="onLogout">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </el-col>
            </el-row>
        </el-header>



        <el-container class="hd">
            <el-aside width="200px" :class="!isShowMenu ? 'asideHide' : 'asideShow'" :style="{marginLeft : menuLeftWidth + 'px'}">
                <el-menu :default-active="menuActive">

                    <el-menu-item index="Index" @click="goUrl('Index')">
                        <i class="el-icon-s-home"></i>
                        <span slot="title">主页</span>
                    </el-menu-item>

                    <el-submenu index="baseManage">
                        <template slot="title"><i class="el-icon-collection"></i>基本管理</template>
                        <el-menu-item index="typeManage" @click="goUrl('typeManage')">版本管理</el-menu-item>
                        <el-menu-item index="baseTypeTree" @click="goUrl('baseTypeTree')">同步目录</el-menu-item>
                        <el-menu-item index="workList" @click="goUrl('workList')">单词列表</el-menu-item>
                        <el-menu-item index="questionList" @click="goUrl('questionList')">题目列表</el-menu-item>
                        <el-menu-item index="wordType" @click="goUrl('wordType')">词类列表</el-menu-item>
                    </el-submenu>
                    <el-submenu index="workBook">
                        <template slot="title"><i class="el-icon-collection"></i>单词本</template>
                        <el-menu-item index="synchronizeWordBook" @click="goUrl('synchronizeWordBook')">同步单词本</el-menu-item>
                        <el-menu-item index="frequentlyWordBook" @click="goUrl('frequentlyWordBook')">高频单词本</el-menu-item>
                    </el-submenu>
                    <el-submenu index="user">
                        <template slot="title"><i class="el-icon-collection"></i>用户管理</template>
                        <el-menu-item index="userManage" @click="goUrl('userManage')">学生列表</el-menu-item>
                    </el-submenu>

                </el-menu>
            </el-aside>
            <div class="iconSwitch" @click="menuSwitch"  :class="!isShowMenu ? 'asideHide' : 'asideShow'" >
                <i class="el-icon-caret-left" v-show="isShowMenu"></i>
                <i class="el-icon-caret-right" v-show="!isShowMenu"></i>
            </div>
            <el-main id="main">
                <div class="main">
                    <router-view></router-view>
                </div>
            </el-main>

        </el-container>
    </el-container>

</template>
<script>
// import dialogDownload from '@/components/testPaper/dialogDownload'
import loginApi from '@/api/login'
import {mapGetters} from 'vuex'

// import {communalApi, updataPssword} from '../../api/index'

export default {
    components: {
        // dialogDownload,
    },
    data () {
        return {
            menuLeftWidth : 0,
            isShowMenu : true,
            //可选中得路由，用于菜单选择
            inRouters : ['Index','typeManage','workList','articleManage','baseTypeTree','questionList',
                'synchronizeWordBook','frequentlyWordBook','wordType','userManage'],
            menuActive: 'Index',
            userName: '',
            logo: require('../../../public/assets/images/logo.png'),
            levelList: [],
            userInfo: {},
            userGroupLength: 0,
            updataPsd: false, // 修改密码的弹窗
            form: {
                oldPassword: '', // 原密码
                newPassword: '', // 新密码
                rePassword: '', // 确定新密码
            },
            rules: Object.freeze({
                oldPassword: [
                    {required: true, message: '请输入原密码', trigger: 'blur'},
                    {min: 6, max: 30, message: '最少6位', trigger: 'blur'},
                ],
                newPassword: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                    {min: 6, max: 30, message: '最少6位', trigger: 'blur'},
                ],
                rePassword: [
                    {required: true, message: '请输入确认密码', trigger: 'blur'},
                    {min: 6, max: 30, message: '最少6位', trigger: 'blur'},
                ],
            }),
        }
    },
    watch: {
        $route() {
            this.getBreadcrumb()
        },
    },
    created () {
        this.getBreadcrumb()
    },
    computed: {
        ...mapGetters({
            getUser : 'getUser'
        })
    },
    mounted () {

    },
    methods: {
        //正则判断是否为手机号
        isPhoneNo (phone) {
            var pattern = /^1[0-9]{10}$/
            return pattern.test(phone)
        },

        onLogout () {
            // console.log('userInfo',this.userInfo)
            // console.log(this.$store.state.userInfo) //vuex数据
            loginApi.logout().then(data => {
                console.log(data)
                if (data.success) {
                    localStorage.removeItem('userInfo', 'logId')
                    this.userInfo = {}
                    this.$store.state.userInfo = {}
                    this.$router.push({path: '/login'})
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 修改密码
        sendPsd (form) {
            return
            /*this.$refs[form].validate(async (valid) => {
                if (!valid) return
                if (this.form.newPassword !== this.form.rePassword) {
                    this.$message.error('新密码和确认密码不一样')
                    return
                }
                const {oldPassword, newPassword, rePassword} = this.form
                const res = await updataPssword({
                    oldPassword,
                    newPassword,
                    rePassword,
                })
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    })
                } else {
                    this.$message.error(res.msg)
                }
                this.cancle()
            })*/
        },
        // 取消修改密码
        cancle () {
            /*this.form = {
                oldPsd: '', // 原密码
                newPsd: '', // 新密码
                sureNewpsd: '', // 确定新密码
            }
            this.updataPsd = false*/
        },
        getBreadcrumb () {
            if (!localStorage.getItem('token') || !this.getUser){
                this.$router.push({name : 'Login'})
                return
            }
            this.userInfo = this.getUser
            console.log('userinfo', this.userInfo)
            this.levelList = []
            let menuActive = '';
            this.$route.matched.forEach(item => {
                this.levelList.push(item)
                if (this.inRouters.indexOf(item.name) >= 0){
                    menuActive = item.name
                }
            })
            this.menuActive = menuActive
        },
        goUrl (name, params = {}) {
            console.log('go name : ',name)
            if (this.$route.name === name){
                return true
            }
            this.$router.push({name: name, query : params})
        },
        menuSwitch(){
            this.isShowMenu = !this.isShowMenu;
            console.log( this.isShowMenu ? '显示目录' : '隐藏目录')
        }
    },
}
</script>
<style lang="scss" scoped>

#doc {
    font-size: 14px;

    .logo{
        height: 50px;
        border-bottom: 1px solid #e6e6e6;
        width: 200px;
        float: left;
        .el-image {
            width: 40px;
            height: 40px;
            margin: 5px 20px;
            float: left;
        }
        span{
            color: #000000;
            line-height: 50px;
            font-weight: bold;
        }
    }
    .el-aside{
        padding-top: 1px;
        margin-left: 0;
    }
    .asideHide {
        color: #019fe8;
        margin-left: -200px !important;
        transition: margin-left 0.3s ease-out;
    }
    .asideShow {
        color: #019fe8;
        margin-left: 0 !important;
        transition: margin-left 0.3s ease-out;
        //left: 174px;
    }
    /deep/ .iconSwitch{
        position: fixed;
        overflow: hidden;
        top: 50px;
        left: 200px;
        i{
            font-size: 40px;
            color: #019fe8;
        }
    }
    .el-header {
        padding: 0;
        margin: 0 auto;
        color: #fff;
        width: 100%;
        .el-row{
            height: 50px;
        }
        height: 50px;
        line-height: 50px;
        //background-color: $primary-color;
        background-color: #FFFFFF;
        // box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);


        .head_l {
            color: #000000;
            text-align: left;
            height: 50px;

            /deep/ .el-breadcrumb{
                line-height: 50px !important;
                height: 50px !important;
                padding: 0 20px;
            }
            span {
                //margin-right: 20px;
                cursor: pointer;
                padding-left: 5px;
                border-radius: 2px;
            }

            span:hover {
                //text-decoration: underline;
                //background-color: #019fe8;
                color: #019fe8;
            }
        }

        .head_r {
            text-align: right;
            margin-right: 10px;

            div {
                cursor: pointer;
                border-radius: 2px;
            }

            div:hover {
                span {
                    color: #019fe8;
                }
            }

            .role {
                cursor: pointer;
                color: #000000;
            }

            .el-dropdown-link {
                cursor: pointer;
                color: #000000;
                margin-right: 15px;
            }

            .el-icon-arrow-down {
                font-size: 12px;
            }
        }
    }

    #main {
        height: calc(100vh - 50px);
        background-color: #f5f7f9;

        .main {
            // width: 1280px;
            min-width: 720px;
            max-width: 1920px;
            margin: 0 auto;

            .bread {
                margin-bottom: 20px;

                .el-breadcrumb {
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/container/Container.vue